export default "__VITE_ASSET__BuD4Nwmk__"